import React from 'react'

const SearchBar = ({ className, searchTerm, setSearchTerm, placeholder, icon, setShowFilter, showFilter}) => {
    return (
        <div className={className ? className : 'searchContainer'}>
            <img src="/assets/icons/search.svg" alt="search-icon" className="searchbar-icon" />
            <input value={searchTerm} onChange={(e) =>setSearchTerm(e.target.value)} type="search" name="search" placeholder={placeholder} className='c-list-search' />
            {icon && <img src={icon} alt="filter-icon" onClick={()=>setShowFilter(!showFilter)} />}
        </div>
    )
}

export default SearchBar